<template>
  <v-container fluid id="fcreate">
    <breadcrumbs/>
    <v-row>
      <v-col>
        <div
          class="text-h3 mb-2"
          v-text="'Создать подборку'"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-form v-model="valid" ref="form">
        <v-container fluid>
          <v-row>
            <!-- Заголовок -->
            <v-col
              cols="12"
              md="7"
            >
              <v-text-field
                v-model="data.name"
                label="Заголовок"
                outlined
                required
                :rules="rules.required"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Подзаголовок -->
            <v-col
              cols="12"
              md="7"
            >
              <v-text-field
                v-model="data.subTitle"
                label="Подзаголовок"
                outlined
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Слаг -->
            <v-col
              cols="12"
              md="7"
            >
              <v-text-field
                v-model="data.slug"
                label="Слаг"
                outlined
                required
                :rules="rules.slug"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Описание -->
            <v-col
              cols="12"
              md="7"
            >
              <v-textarea
                v-model="data.description"
                label="Описание"
                outlined
                required
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Иконка -->
            <v-col
              cols="12"
              md="7"
            >
              <div
                class="text-body mb-2"
                v-text="'Иконка'"
              />
              <upload-image
                v-model="data.ico"
                color="primary"
                label="Загрузить иконку"
              >
                Загрузить иконку
              </upload-image>
            </v-col>
            <!-- Тип -->
            <v-col
              cols="12"
              md="7"
            >
              <v-select
                v-model="data.types"
                :items="['desktop', 'mobile', 'crm']"
                label="Тип"
                outlined
                multiple
                :rules="rules.selectMultipleRequired"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Цель -->
            <v-col
              cols="12"
              md="7"
            >
              <v-text-field
                v-model="data.target"
                label="Цель"
                outlined
                required
                :rules="rules.required"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Сортировка -->
            <v-col
              cols="12"
              md="7"
            >
              <v-text-field
                v-model="data.sortOrder"
                label="Индекс сортировки"
                outlined
                required
                :rules="rules.requiredNumber"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Категория -->
            <v-col
              cols="12"
              md="7"
            >
              <v-select
                v-model="data.categoryId"
                :items="getCategoriesList"
                item-text="name"
                item-value="id"
                label="Категория"
                outlined
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Блюда в подборке -->
            <v-col
              cols="12"
              md="7"
            >
              <v-autocomplete
                v-model="menuItems.model"
                :items="getMenuItemsList"
                item-text="name"
                item-value="id"
                label="Блюда в подборке"
                outlined
                chips
                deletable-chips
                multiple
                :rules="rules.selectMultipleRequired"
                :disabled="loading"
                :loading="loading"
              />
            </v-col>
            <!-- Submit -->
            <v-col
              cols="12"
              md="7"
            >
              <v-row>
                <v-col>
                  <v-btn
                    block
                    class="mb-2"
                    large
                    color="success"
                    :loading="loading"
                    :disabled="loading"
                    @click.prevent="submit"
                  >
                    Создать
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn
                    block
                    large
                    color="primary"
                    :loading="loading"
                    :disabled="loading"
                    @click.prevent="$router.back()"
                  >
                    Отмена
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-row>
    <v-snackbar v-model="snackbar">
      Исправьте ошибки и повторите попытку
      <template v-slot:action="{ attrs }">
        <v-btn
          color="red"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Закрыть
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import UploadImage from './../../components/UploadImage'
  import rules from '@/mixins/rules'

  export default {
    mixins: [rules],
    components: { UploadImage },
    data () {
      return {
        data: {
          name: '',
          subTitle: '',
          slug: '',
          ico: '',
          types: [],
          target: '',
          description: '',
          menuItems: [],
          categoryId: null,
          sortOrder: 1,
          status: true,
        },
        menuItems: {
          model: [],
          data: [],
        },
        valid: false,
        loading: false,
        snackbar: false,
      }
    },
    computed: {
      ...mapGetters({
        getCategoriesList: 'categories/getCategoriesList',
        getMenuItemsList: 'menuItems/getMenuItemsList',
      }),
    },
    watch: {
      'menuItems.model' (newValue) {
        this.menuItems.data = newValue.map(v => {
          return {
            id: v,
          }
        })
      },
    },
    created () {
      this.$store.dispatch('categories/fetchCategoriesList', {
        limit: 10000,
        offset: 0,
        page: 0,
      })

      this.$store.dispatch('menuItems/fetchMenuItemsList', {
        limit: 10000,
        offset: 0,
        page: 0,
      })
    },
    methods: {
      async submit () {
        this.loading = true

        const validate = await this.$refs.form.validate()

        if (validate) {
          try {
            this.data.menuItems = this.menuItems.data
            const res = await this.$store.dispatch('collections/createCollections', this.data)
            if (res.status && res.status === 200) {
              this.$router.push('/collections')
            }
          } catch (e) { console.log(e) }
        } else {
          this.snackbar = true
          document.getElementById('fcreate').scrollIntoView({
            behavior: 'smooth',
          })

          setTimeout(() => {
            this.snackbar = false
          }, 3000)
        }

        this.loading = false
      },
    },
  }
</script>
